import { getFullName } from '@models/User';
import { addTime, compareDates } from '@utils/dates';
import { sessionStates } from '@constants/index';
import { getSpecialInfoString } from '@models/Item';

const getAuthor = (author = {}) => {
  const { firstName, lastName } = author;
  return { ...author, name: getFullName(firstName, lastName) };
};

export const getLatestSession = (session) => ({
  correctCount: session.correctCount,
  incorrectCount: session.incorrectCount,
  finishedAt: session.finishedAt ? new Date(session.finishedAt) : null,
  isLive: session.isLive,
  score: session.score,
  skippedCount: session.skippedCount,
  startTime: session.startTime,
  uid: session.uid
});

export const slides = (pdf) => {
  const slidesObject = {};
  if (pdf?.withAnnotation) {
    slidesObject.withAnnotations = pdf.withAnnotation;
  }
  if (pdf?.noAnnotation) {
    slidesObject.withoutAnnotations = pdf.noAnnotation;
  }
  return slidesObject;
};

const formatClassData = (itemData = {}) => {
  const data = {
    ...itemData,
    ...itemData?.properties,
    type: itemData.type ?? 'post',
    contentRank: itemData.contentTypeItemRank || itemData.rank,
    courseUID: itemData?.properties?.programme?.uid,
    courseSlug: itemData?.properties?.programme?.slug,
    goal: itemData?.properties?.programme?.goal,
    batchGroup: itemData?.batchGroup ?? null,
    author: getAuthor(itemData?.properties?.author),
    topicGroups: itemData?.topicGroups || []
  };
  const item = itemData?.properties ? itemData?.properties : itemData;
  data.liveAt = item.liveAt ? new Date(item.liveAt) : new Date(item.startTime);
  data.liveAtString = item.liveAt || item.startTime;
  data.liveAtTime = new Date(item.liveAt || item.startTime).getTime();
  data.startedAt = item.startedAt ? new Date(item.startedAt) : null;
  data.startsAt = item.startTime || null;
  data.goalName = item.goalName || item.programme?.goal?.name || null;
  data.hasWatched = item.hasWatched || item.watched;
  data.videoUrl = item.videoUrl || item.video?.url;
  data.lessonDuration =
    item.videoDuration || item.video?.duration || item.duration;
  data.endsAt = addTime(data.liveAt, data.lessonDuration, 's');
  data.finishedAt = item.finishedAt ? new Date(item.finishedAt) : data.endsAt;
  data.isPdfAvailable = item.video?.isPdfAvailable;
  data.isLive =
    item.isLive || data.type === 'post'
      ? item.state === sessionStates.LIVE
      : data.secondsBeforeLive === 0 &&
        compareDates(new Date(), data.startsAt) === 0;
  data.slidesPdf = data?.slidesPdf ? slides(data.slidesPdf) : null;
  data.latestSession = item.latestSession
    ? getLatestSession(item.latestSession)
    : null;
  data.specialInfoString =
    data.type === 'post' || data.classType === 1
      ? getSpecialInfoString(data)
      : '';
  data.isBookmarked = item.isBookmarked || item.bookmarked || false;
  data.liveClassDetails = item.value?.liveClass || item?.liveClass2;

  return data;
};

export default formatClassData;
